module.exports = "<h1>Erreur 404</h1>\n\n<p>TO DO : personnaliser cette page</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/Uclics/demo/angular/src/app/components/error-page/error-page.component.html
// module id = ../../../../../src/app/components/error-page/error-page.component.html
// module chunks = main